import { useState, useCallback } from 'react';
import { apiRequest } from '../../utils/apiUtils';
import { VenueComplex } from '../../types/venue';

interface UseComplexDetailReturn {
  complex: VenueComplex | null;
  loading: boolean;
  error: string | null;
  fetchComplex: () => Promise<void>;
  refetch: () => Promise<void>;
}

export const useComplexDetail = (complexId?: string): UseComplexDetailReturn => {
  const [complex, setComplex] = useState<VenueComplex | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchComplex = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      // Si hay ID específico, buscar por ID. Si no, obtener el complejo del owner actual.
      const endpoint = complexId ? `/complexes/${complexId}` : '/complexes/complex';
      const response = await apiRequest<{ complex: VenueComplex }>(endpoint);

      if (response.data?.complex) {
        setComplex(response.data.complex);
      } else {
        setError(response.error || 'Complejo no encontrado');
      }
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.error('Error fetching complex:', err);
      setError(err.message || 'Error al cargar el complejo');
    } finally {
      setLoading(false);
    }
  }, [complexId]);

  return {
    complex,
    loading,
    error,
    fetchComplex,
    refetch: fetchComplex,
  };
};
